import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardImg, CardText, CardTitle } from 'reactstrap';
function FeatureServices() {
    return (
        <div>
            <div className="row align-items-center">
                <div className="col-xl-4 col-lg-4 mb-8 mb-lg-0">
                    <Card className={`px-4 py-7 rounded hover-translate text-center border-0 bg-white shadow`}>
                        <CardImg top src={require('../../assets/images/svg/01.svg').default} alt="testimage" />
                        <CardBody>
                            <CardTitle tag="h5" className="mt-4 mb-3">Web-based System</CardTitle>
                            <CardText>Could be used in web browser i.e. Google Chrome, Mozilla Firefox, and Safari </CardText>
                        </CardBody>
                    </Card>
                </div>
                <div className="col-xl-4 col-lg-4 col-sm-6">
                    <Card className={`px-4 py-7 rounded hover-translate text-center bg-white shadow border-0`}>
                        <CardImg top src={require('../../assets/images/svg/08.svg').default} alt="testimage" />
                        <CardBody>
                            <CardTitle tag="h5" className="mt-4 mb-3">Mobile Apps</CardTitle>
                            <CardText>Could be installed from Play Store / App Store on users' device</CardText>
                        </CardBody>
                    </Card>
                </div>
                <div className="col-xl-4 col-lg-4 col-sm-6 mt-6 mt-sm-0">
                    <Card className={`px-4 py-7 rounded hover-translate text-center border-0 bg-white shadow`}>
                        <CardImg top src={require('../../assets/images/svg/03.svg').default} alt="testimage" />
                        <CardBody>
                            <CardTitle tag="h5" className="mt-4 mb-3">Others</CardTitle>
                            <p>Could be integrated with KIOSK, POS, IoT hardwares, dan other devices</p>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </div>
    )
}

export default FeatureServices;